<!--
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-02-15 16:52:51
 * @LastEditors: wangcan
 * @LastEditTime: 2023-10-08 14:00:20
-->
<template>
  <div class="companyDetail">
   <van-nav-bar left-arrow @click-left="goBack" title="企业信息" />
    <div class="company">
      <div class="compInfo">
        <div class="img"><img :src="comList.logoPath" alt="" /></div>
        <div class="info">
          <h3>{{ comList.name }}</h3>
          <div class="infos">
            <span>{{ comList.address }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap-bg">
      <h3>招聘岗位</h3>
      <div class="positionBox">
        <ul v-if="positionList.length > 0">
          <li v-for="(v, i) in positionList" :key="i" @click="postDetail(v)">
            <h4>
              {{ v.name }}<span>{{ v.formalSalary }}</span>
            </h4>
            <div class="info">
              <span>{{ v.address ? v.address : "-" }}</span> |
              <span>招聘{{ v.recruitNum }}人</span>
            </div>
            <div
              class="infos"
              @click="
                getPositionModel(v.jobResponsibilities, v.jobRequirements)
              "
            >
              <p>
                 岗位职责：
               <div v-html="v.jobResponsibilities ? v.jobResponsibilities : '-'"></div>
              </p>
              <p>
                岗位要求：
                <div v-html="v.jobRequirements ? v.jobRequirements : '-'"></div>
                </p>
            </div>
            <!-- <el-button
              class="send-resume"
              type="primary"
              @click="sendResumeMobile(v.meetingPostId)"
              >投递简历</el-button
            > -->
            <van-button class="send-resume" type="info" size="small" @click.stop="sendResumeMobile(v.meetingPostId)">投递简历</van-button>
          </li>
        </ul>
        <van-empty v-else description="该企业还未添加招聘岗位" />
      </div>
    </div>
    <div class="wrap-bg company-detail">
      <h3>公司简介</h3>
      <div class="descript" v-html="comList.companyProfile"></div>
      <h3>公司信息</h3>
      <div class="com-info">
          <div class="companyIntroduce">
            <span>企业名称：</span>{{ comList.name }}
          </div>
          <div class="companyIntroduce">
            <span>企业网址：</span>{{ comList.website }}
          </div>
          <div class="companyIntroduce">
            <span>公司规模：</span>{{ comList.scale }}
          </div>
          <div class="companyIntroduce">
            <span>公司地址：</span>{{ comList.address }}
          </div>
      </div>
    </div>
    <!-- <el-dialog title="岗位详情" :visible.sync="positionModel" width="800px" :class="isMobile ? 'is-mobile' : ''" :fullscreen="isMobile?true:false">
      <div class="positionModel">
        <h3>岗位职责：</h3>
        <div v-html="detailText"></div>
        <h3>岗位要求：</h3>
        <div v-html="detailTextElse"></div>
      </div>
    </el-dialog> -->
    <!-- 弹窗, 新增  -->
    <!-- <SendAdd v-if="sendAddVisible" ref="sendAdd"></SendAdd> -->
  </div>
</template>
<script>
// import SendAdd from "./send-add";
import { getMeetingCompanyInfo } from "@/api/common";
export default {
  data() {
    return {
      comList: {},
      positionList: [],
      positionModel: false,
      detailText: "",
      detailTextElse: "",
      sendAddVisible: false,
      meetingCompanyId: 0,
      uploadUrlPre:"https://mhys-cloud-class.oss-cn-beijing.aliyuncs.com/jyglUpload/"
    };
  },
  created(){
console.log(333333);
    document.body.scrollTop=document.documentElement.scrollTop=-10
  },
  // components: { SendAdd },
  mounted() {
    
      this.meetingCompanyId = this.$route.query.meetingCompanyId;
    
    this.geDetail(this.meetingCompanyId);
  },
  methods: {
    getPositionModel(jobIntroduce, jobRequirements) {
      this.positionModel = !this.positionModel;
      this.detailText = jobIntroduce;
      this.detailTextElse = jobRequirements;
    },
    goBack() {
      this.$router.go(-1);
    },
    geDetail(meetingCompanyId) {
      if (meetingCompanyId) {
        getMeetingCompanyInfo(meetingCompanyId).then(({ data }) => {
          if (data && data.code === 200) {
            if (
              data.data.logoPath &&
              data.data.logoPath != null &&
              data.data.logoPath != ""
            ) {
                data.data.logoPath =this.uploadUrlPre + data.data.logoPath;
              // data.data.logoPath =
              //     process.env.NODE_ENV != "production"
              //       ? window.SITE_CONFIG.base_url_dev + "/" + data.data.logoPath
              //       : window.SITE_CONFIG.base_url + "/" + data.data.logoPath;
            } else {
              data.data.logoPath = require("../assets/img/company-img-empty.png");
            }
            this.comList = data.data;
            data.data.postList.forEach(v => {
              v.jobResponsibilities = v.jobResponsibilities.replace(
                /\n/g,
                "<br/>"
              );
              v.jobRequirements = v.jobRequirements.replace(/\n/g, "<br/>");
            });
            this.positionList = data.data.postList;
          }
        });
      } else {
        this.$router.go(-1);
        // this.$router.push({
        //   name: "applyDetail"
        // });
      }
    },
    /**
     * @name: 投递简历 -web端
     * @param {*} id
     */

    sendResume(id) {
      this.sendAddVisible = true;
      this.$nextTick(() => {
        this.$refs.sendAdd.init(id);
      });
    },

    /**
     * @name: 投递简历-手机端
     * @param {*} id
     */

    sendResumeMobile(id) {
      this.$router.push({
        name: "sendAddMobile",
        query: {
          id: id
        }
      });
    },
    /**
     * @name: 岗位详情
     */    
    postDetail(v){ 
      this.$router.push({
        name: "postDetail",
        // params: {
        //   // item: JSON.stringify(v || '{}')
        //   item: v
        // }
        query: {
          item: JSON.stringify(v || '{}')
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$--color-primary: #266eff;
.companyDetail {
  font-size: .36rem;
  color: #323233;
  .send-resume{
    float: right;
  }
  .company {
    width: 100%;
    padding: .3rem;
    box-sizing: border-box;

    // box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    .compInfo {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .img {
        //   background-color: #e4e4e4;
        //   border-radius: 4px;
        margin-right: .2rem;
        width: 2rem;
        height: 2rem;
        justify-content: center;
        display: flex;
        align-items: center;

        img {
        width: 2rem;
        height: 2rem;
        }
      }

      .info {
        h3 {
          font-size: .44rem;
          margin-bottom: .2rem;
          // margin-top: 10px;
        }

        .infos {
          color: #999;
          font-size: .32rem;
          line-height: .44rem;
        }
      }
    }
  }

  .wrap-bg {
    background: #f8f8f8;
    margin:0 .3rem .3rem;
    &.company-detail {
      padding-top: .1rem;
      padding-bottom: .4rem;
    }

    h3 {
      padding: .3rem .4rem .26rem;
      font-size: .42rem;
      font-weight: normal;
    }

    .descript {
      color: #666;
        line-height: .7rem;
      padding: 0 .4rem;
      text-indent: .8rem;
    }

    .com-info {
padding: 0 .4rem;
      .companyIntroduce {
        line-height: .7rem;
margin-bottom: .1rem;
        span {
          color: #999;
        }
      }
    }
  }

  .positionBox {
    width: 100%;

    ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // @include display-flex(flex-start);
      flex-wrap: wrap;
      padding: 0;
margin: 0 .2rem;
      li {
        width: calc(100% - .8rem);
        margin: 0 .2rem .2rem;
        box-sizing: border-box;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        padding: .4rem;
        border-radius: .05rem;
        overflow: hidden;
        position: relative;
        margin-bottom: .3rem;
        background: #fff;

        // &:nth-child(4n) {
        //   margin-right: 0px;
        // }
        h4 {
          color: $--color-primary;
          font-weight: normal;
          margin: 0 0 .2rem;
          position: relative;
          font-size: .42rem;

          span {
            position: absolute;
            top: 0;
            right: 0;
            color: #ff3326;
          }
        }

        .info {
          margin-bottom: .1rem;
          color: #999;
          font-size: .32rem;
        }

        .infos {
          font-size: .36rem;
          line-height: .6rem;
          width: 100%;
          //   @include text-overflow;
          margin: .2rem 0;
          overflow: hidden;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          height: 1.8rem;
          &:hover {
            color: $--color-primary;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.companyDetail {
  .infos {
    -webkit-line-clamp: 3 !important;
  }
}
@media only screen and (min-width: 1000px) {
  .companyDetail .positionBox ul li {
    width: calc(50% - .6rem);
  }
}
// @media only screen and (max-width: 1200px) {
//   .companyDetail .positionBox ul li {
//     width: calc(50% - 20px);
//   }
// }
// @media only screen and (max-width: 700px) {
//   .companyDetail .positionBox ul li {
//     width: 100%;
//     margin-right: 0 !important;
//     margin-left: 0 !important;
//   }
//   .companyDetail .wrap-bg {
//     margin: 10px;
//     padding: 0 20px;
//   }
// }
</style>